import { Injectable } from "@angular/core";
import { AbstractControl } from "@angular/forms";
import { Store } from "@ngrx/store";
import { CommonState } from "@obg/ngx.common";
import { FeatureFlagService } from "@obg/ngx.global";
import { RouteAction, RouteSelector } from "@obg/ngx.router";
import { merge } from "rxjs";
import { filter, map, take, tap } from "rxjs/operators";

import { FabricForgotPasswordFeatureFlag } from "./forgot-password.model";
export const FABRIC_FORGOT_PASSWORD_FEATURE_FLAG_KEY = "mfe_forgot_password";

@Injectable()
export class ForgotPasswordService {
	constructor(
		private store: Store<CommonState>,
		private featureFlagService: FeatureFlagService
	) {}

	setUsername$(usernameControl: AbstractControl) {
		return merge(
			this.store.select(RouteSelector.getExtras),
			this.store.select(RouteSelector.getAdditionalData)
		).pipe(
			filter((data) => data?.state?.username?.includes("@") || data?.username?.includes("@")),
			map((data) => data.state?.username ?? data.username),
			take(1),
			tap((username) => {
				usernameControl.setValue(username);
				this.store.dispatch(RouteAction.setAdditionalData(undefined));
			})
		);
	}

	getFabricForgotPasswordFeatureFlag(): boolean {
		const flag = this.featureFlagService.get<FabricForgotPasswordFeatureFlag | undefined>(
			FABRIC_FORGOT_PASSWORD_FEATURE_FLAG_KEY
		);
		return !!flag?.enabled;
	}
}
